import { v7 as uuidv7 } from 'uuid';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type InviteEntryPoint =
  'app_tracker' | 'll_portal_homepage' | 'direct_link' | 'invite_another_renter_button';

// Lives outside the store state: the form reports every dirty flip, and nothing should re-render
// for it — only the close guard reads it, on demand.
let isFormDirtyFlag = false;

interface InviteLeaseDetailsDrawerState {
  isOpen: boolean;
  formKey: number;
  flowId: string | null;
  entryPoint: InviteEntryPoint | null;
  fromUrl: string | null;
  newDealEmail: string | null;
  openDrawer: (entryPoint?: InviteEntryPoint, fromUrl?: string) => void;
  openCleanForm: (entryPoint?: InviteEntryPoint, fromUrl?: string) => void;
  closeDrawer: () => void;
  setNewDealEmail: (email: string | null) => void;
  clearNewDealEmail: () => void;
  /** Called by the invite form whenever its dirty state flips. */
  reportFormDirty: (isDirty: boolean) => void;
  isFormDirty: () => boolean;
}

export const useInviteLeaseDetailsDrawerStore = create<InviteLeaseDetailsDrawerState>()(
  devtools(
    (): InviteLeaseDetailsDrawerState => ({
      isOpen: false,
      formKey: 0,
      flowId: null,
      entryPoint: null,
      fromUrl: null,
      newDealEmail: null,
      openDrawer: (entryPoint?: InviteEntryPoint, fromUrl?: string) => {
        useInviteLeaseDetailsDrawerStore.setState((state) => {
          if (state.isOpen) {
            return state;
          }
          isFormDirtyFlag = false;
          return {
            isOpen: true,
            formKey: state.formKey + 1,
            flowId: uuidv7(),
            entryPoint: entryPoint ?? null,
            fromUrl: fromUrl ?? null,
          };
        });
      },
      openCleanForm: (entryPoint?: InviteEntryPoint, fromUrl?: string) => {
        isFormDirtyFlag = false;
        useInviteLeaseDetailsDrawerStore.setState((state) => ({
          isOpen: true,
          formKey: state.formKey + 1,
          flowId: uuidv7(),
          entryPoint: entryPoint ?? null,
          fromUrl: fromUrl ?? null,
        }));
      },
      closeDrawer: () => {
        isFormDirtyFlag = false;
        useInviteLeaseDetailsDrawerStore.setState({
          isOpen: false,
          flowId: null,
          entryPoint: null,
          fromUrl: null,
        });
      },
      setNewDealEmail: (email: string | null) => {
        useInviteLeaseDetailsDrawerStore.setState({ newDealEmail: email });
      },
      clearNewDealEmail: () => {
        useInviteLeaseDetailsDrawerStore.setState({ newDealEmail: null });
      },
      reportFormDirty: (isDirty: boolean) => {
        isFormDirtyFlag = isDirty;
      },
      isFormDirty: () => isFormDirtyFlag,
    }),
    { name: 'invite-lease-details-drawer-store' },
  ),
);
